const TextTransformation = (text) => {
  const textList = {
    // Product Categories
    main_course: 'Main course',
    starters_and_sides: 'Starters & Sides',
    desserts_and_drinks: 'Desserts & drinks',
    party_pack: 'Party pack',
    main_dish: 'Main dish',
    kids_menu: 'Kids menu',
    buy_one_get_one_free: 'Buy 1, Get 1 Free',
    buy_two_get_one_free: 'Buy 2, Get 1 Free',
    buy_one_get_half_price: 'Buy 1,Get 1 Half',

    admin_review_pending: 'Admin review pending', // admin  && kitchen merchant

    approved: 'Approved', // admin
    merchant_image_review_pending: 'Merchant image review pending', //admin
    merchant_content_review_pending: 'Merchant content review pending', // admin
    content_rejected_by_admin: 'Content rejected by admin', // admin
    image_rejected_by_admin: 'Image rejected by admin', // admin

    content_rejected_by_merchant: 'Content rejected by merchant', //kitchen merchant
    image_rejected_by_merchant: 'Image rejected by merchant', //kitchen merchant
    content_approved_merchant: 'content approved merchant', //kitchen merchant
    merchant_review_pending: 'Merchant review pending', //kitchen merchant
    pause: 'Pause', //kitchen merchant
    unpause: 'unpause', //kitchen merchant
    admin_rejected: 'Admin rejected', //admin
    ai_generated_merchant_review_pending: 'AI generated merchant review pending', //kitchen merchant
  };

  return textList[text] || text;
};

export default TextTransformation;
